import Notifications from './components/Notifications.html';
import App from './App.html';
import LoadFonts from './lib/load-fonts';
import { create, valueOf } from 'microstates';
import { constructAppState, store } from './stores';
import { LINE_LENGTH } from './lib/constants';

export const SASEditor = async ({
  target,
  occasions,
  messages,
  back,
  forward,
  backText,
  forwardText,
  endpoint,
  format,
  fontFace = {
    name: 'Nothing You Could Do',
    family: 'Nothing You Could Do',
    size: 18
  },
  isGoogleFont = true,
  spaceChar = 'n',
  lineLengths = [LINE_LENGTH],
  center = false,
  tolerance = 5,
  withHyphenation = false,
  text = '',
  logoSrc = '',
  noteInsertGifSrc = '',
  headers = {},
  noteResourceId = null,
  noticeError = (x) => { console.error('========\n\nNo logger passed into note-editor. Default to `throw`ing.\n\n========'); throw new Error(x) },
  bannedPhrases = [],
  terms = 'https://www.lovepopcards.com/3676021/policies/1390313.html'
}) => {

  if (typeof endpoint === 'undefined') {
    throw Error('`endpoint` is undefined. example: `https://devapi.lovepopcards.com`, `https://stgapi.lovepopcards.com` `https://api.lovepop.com`');
  }

  const appState = await constructAppState({
    occasions,
    messages,
    text,
    headers,
    noteResourceId,
    endpoint,
    fontFace,
    format,
    logoSrc,
    noteInsertGifSrc,
    spaceChar,
    center,
    lineLengths,
    withHyphenation,
    back,
    forward,
    backText,
    forwardText,
    noticeError,
    bannedPhrases,
    terms
  });

  store.set(appState);

  /*
   * Extract the errors from the app state and pass
   * to the Notifications component
   */

  if (appState.hasErrors) {
    const errors = valueOf(appState.errors.errors);
    const notifications =  new Notifications({ target, props: { errors } });
    return errors.forEach(e => notifications.error(e.message));
  }

  const app = new App({ target });

  /*
   * TODO: test shopify integration still works
   */
  let previousMessageModalState;
  store.subscribe(s => {
    if (previousMessageModalState !== s.isChoosingMessage.state) {
      previousMessageModalState = s.isChoosingMessage.state;
      app.dispatch('isMessageModalOpen', s.isChoosingMessage.state);
    }
  });

  let previousColorModalState;
  store.subscribe(s => {
    if (previousColorModalState !== s.showColorModal.state) {
      previousColorModalState = s.showColorModal.state;
      app.dispatch('isColorModalOpen', s.showColorModal.state);
    }
  });

  let previousFontModalState;
  store.subscribe(s => {
    if (previousFontModalState !== s.showFontModal.state) {
      previousFontModalState = s.showFontModal.state;
      app.dispatch('isFontModalOpen', s.showFontModal.state);
    }
  });

  return new Promise((resolve) => {
    const returnEditor = () => resolve(app);
    return isGoogleFont
      ? LoadFonts([fontFace.family]).then(returnEditor)
      : returnEditor()
  });
};
